<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="logout"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <!-- SE UTENTE NON CENSITO COME INTERMEDIARIO e/o TITOLARE RICHIEDERE CONFERMA -->

    <h1>Accesso incaricato</h1>

    <!-- INFO current user -->
    <user-info
      :user="user"
      :incaricato="incaricato"
    />

    <loading-spinner v-if="loading" />
    <div
      v-else-if="$store.getters.isAuthenticated"
      class="row justify-content-between mx-2 mt-5 mb-2 align-middle"
    >
      <h4>Incarichi</h4>
      <div class="text-right">
        <b-button
          variant="primary"
          @click="onNuovaRichiesta"
        >
          <font-awesome-icon
            icon="plus"
            class="mr-2"
          />Nuova richiesta
        </b-button>
      </div>
    </div>

    <b-alert
      v-if="!loading && !items.length"
      show
      variant="info"
      class="my-4"
    >
      Non ci sono incarichi da visualizzare.
    </b-alert>

    <b-table
      v-else-if="items.length"
      :per-page="perPage"
      :current-page="currentPage"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      :responsive="true"
      :busy="false"
      @row-clicked="onRowClicked"
    >

      <template v-slot:head(icon)>
        <font-awesome-icon
          icon="file-alt"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(icon)="data">
        <!-- <font-awesome-icon v-if="data.item.stato === 'A'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <!-- <font-awesome-icon v-if="data.item.stato === 'C'" icon="search" size="lg" class="text-success cursor-pointer"/> -->

        <!-- <pre>{{data.item.id}}</pre> -->

        <font-awesome-icon
          v-if="data.item.stato === 'B'"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <!-- <font-awesome-icon v-if="data.item.stato === 'P'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'search')"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'pen')"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato === 'V'"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />

      </template>

      <template v-slot:head(abilitato)>
        <font-awesome-icon
          icon="user-circle"
          size="lg"
          class="text-muted"
        />
      </template>

      <!-- <template v-slot:cell(incaricato)="data">
        {{data.item}}
      </template> -->

      <template v-slot:cell(abilitato)="data">
        <b-button
          variant="link"
          @click="selectLogon(data.item)"
          v-if="'45'.search(data.item.codiceStatoAbilitazione) > -1 && new Date() <= new Date(data.item.fineAbilitazione)"
          title="Accedi come incaricato"
        >
          <font-awesome-icon
            :icon="'sign-in-alt'"
            size="lg"
            class="text-success cursor-pointer"
          />
        </b-button>
        <!-- <font-awesome-icon
          v-else
          :icon="'eye-slash'"
          size="lg"
          class="text-success cursor-pointer"
        /> -->

        <b-button
          variant="link"
          @click="onRevocaConfirm(data.item)"
          v-if="('4'.search(data.item.codiceStatoAbilitazione) > -1 && new Date() <= new Date(data.item.fineAbilitazione)) || '5'.search(data.item.codiceStatoAbilitazione) > -1 "
          :title="data.item.statoRevoca === 'V' ? 'Revoca presentata' : 'Revoca la delega'"
        >
          <font-awesome-icon
            :icon="'sign-out-alt'"
            size="lg"
            :class="data.item.statoRevoca === 'V' ? 'text-success' : 'text-danger' + 'cursor-pointer'"
          />
        </b-button>

        <b-button
          @click="data.toggleDetails"
          variant="link"
          v-if="'3456'.search(data.item.codiceStatoAbilitazione) > -1"
          :title="data.item.noteIncaricato"
        >
          <font-awesome-icon
            :icon="!data._showDetails ? 'eye' : 'eye-slash'"
            size="lg"
            class="text-danger cursor-pointer"
          />
        </b-button>

        <!-- Se scaduta mettere divieto -->
        <b-button
          @click="data.toggleDetails"
          variant="link"
          v-if="'36'.search(data.item.codiceStatoAbilitazione) > -1 || (data.item.fineAbilitazione && new Date() > new Date(data.item.fineAbilitazione))"
          title='Abilitazione negata o scaduta'
        >
          <font-awesome-icon
            icon='handshake-alt-slash'
            size="lg"
            class="text-danger cursor-pointer"
          />
        </b-button>

      </template>

      <template #row-details="data">
        <b-card>
          <b-row class="mb-2">
            <b-col
              sm="3"
              class="text-sm-right"
            ><b>Note stato richiesta:</b></b-col>
            <b-col align="left">
              <pre>{{ data.item.noteIncaricato }}</pre>
            </b-col>
          </b-row>

          <!-- <b-button
            size="sm"
            @click="data.toggleDetails"
          >Nascondi</b-button> -->
        </b-card>
      </template>

    </b-table>

    <privacy-intermediario-modal
      ref="modalPrivacy"
      @confermaLettura="letturaConfermata"
    />

    <richiesta-intermediario-modal ref="modal" />

    <accesso-rapporti-utenza-modal
      ref="accessoModal"
      @accediRUSel="onLogonInc"
    />

    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </div>
      <div class="text-right">
        <b-form-group
          description="Per pagina"
          class="mb-0"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment-timezone'
import LoadingSpinner from '@/components/LoadingSpinner'
import UserInfo from '@/components/UserInfo'
import RichiestaIntermediarioModal from '@/components/RichiestaIntermediarioModal'
import PrivacyIntermediarioModal from '@/components/PrivacyIntermediarioModal'
import AccessoRapportiUtenzaModal from '@/components/AccessoRapportiUtenzaBUModal'

const formatValidData = (value, strFormat) => {
  let retValue = ''

  strFormat = strFormat || 'DD/MM/YYYY'

  if (moment(value, 'YYYY-MM-DD', false).isValid()) {
    // retValue = moment(value, 'YYYY-MM-DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else if (moment(value, 'YYYY/MM/DD', false).isValid()) {
    // retValue = moment(value, 'YYYY/MM/DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else {
    // retValue = moment(value, 'DD/MM/YYYY', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  }

  // console.log('Data in format', value, retValue, moment(value).locale('it').tz('Europe/Rome').format('DD MMMM YYYY HH:mm'))
  return moment(retValue, strFormat).isValid() ? retValue : ' - '
}

export default {
  components: {
    LoadingSpinner,
    UserInfo,
    RichiestaIntermediarioModal,
    PrivacyIntermediarioModal,
    AccessoRapportiUtenzaModal
  },
  data () {
    return {
      items: [],
      fields: [
        'icon',
        { key: 'tipoAbilitazione', label: 'Tipo' },
        { key: 'data', label: 'Data', formatter: (value) => { return formatValidData(value, 'DD/MM/YYYY') } },
        // { key: 'cftitolare', label: 'CF titolare' },
        { key: 'titolare', label: 'Titolare' },
        // { key: 'cfncaricato', label: 'CF incaricato' },
        { key: 'incaricato', label: 'Incaricato' },
        { key: 'codiceUtente', label: 'Codice RU' },
        { key: 'codiceUib', label: 'Codice BU' },
        // { key: 'indirizzo', label: 'Indirizzo' },
        { key: 'statoAbilitazione', label: 'Stato richiesta' },
        { key: 'fineAbilitazione', label: 'Fine Validità', formatter: (value) => { return formatValidData(value, 'DD/MM/YYYY') } },
        'abilitato'
      ],
      loading: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      user: {},
      infoTitolare: {},
      incaricato: {},
      lettura: false,
      isDetails: false,
      appRow: null
    }
  },

  async created () {
    await this.load()
  },

  methods: {

    async load () {
      try {
        this.loading = true

        // console.log('Verifica parametri', this.$route.params)

        // Verifica se "rimuovere delega"
        // if (this.$store.state.auth.userInc && this.$store.state.auth.userInc.codiceUtente === 'intermediario') {
        if (this.$route.params && this.$route.params.delega === 'attiva') {
          // Rimuovi delega
          // this.$store.state.auth.user = Object.assign({}, this.$store.state.auth.userInc)
          await this.$store.dispatch('abilitazioni/rimuoviDelega', { user: this.$store.state.auth.user })

          await this.$store.dispatch('info')
        }

        this.user = this.$store.state.auth.user
        // console.log('User: ', this.user, this.$store.state.auth.user.userInc)

        await this.$store.dispatch('abilitazioni/loadIncaricato', this.user)
        await this.$store.dispatch('abilitazioni/loadItems')

        // console.log('Store abilitazioni', this.$store.state.abilitazioni)

        this.items = this.$store.state.abilitazioni.items
        this.incaricato = this.$store.state.abilitazioni.incaricato

        this.totalRows = this.items.length || 0
        // console.log('this.totalRows', this.totalRows)

        // console.log('INTERMEDIARIO load user info', this.user, this.items, this.incaricato)
        // this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid' && this.$store.state.auth.user.validita === 'V'

        // Se l'utente è un titolare accede direttamente alla home page.
        // this.$router.push({ name: 'home' })

      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    onRevocaConfirm (row) {

      this.appRow = Object.assign({}, row)

      if (row.idRevoca) {
        // this.$ui.notify({
        //   type: 'warning',
        //   title: 'Attenzione',
        //   message: 'Tutte le clausole dichiaratorie devono essere accettate prima del salvataggio del documento.'
        // })
        this.$router.push({ name: 'incaricoInc', params: { id: row.idRevoca } })
        // console.log("REVOCA GIA' CREATA", this.appRow)
      } else {
        this.$ui.notify({
          type: 'confirm',
          title: 'Richiesta di conferma',
          message: 'Si vuole procedere con la "richiesta di revoca" della delega?',
          okHandler: this.onRevocaClicked
        })
      }
    },

    async onRevocaClicked () {
      try {

        let row = this.appRow
        let exist = false

        // Verifica la presenza di unma revoca per la delega esistente.
        // Se esiste "" accedi a revoca delega..

        // console.log('Richiesta di revoca della delega: row', row, row.idDelega, row.idRevoca)

        // La revoca non esiste. Chiedere conferma per la creazione.
        // this.$refs.modalPrivacy.open({ confermaLettura: this.lettura })

        // console.log('REVOCA DELEGA: continua!', JSON.stringify(row))
        this.creaDocumentoRevoca(row)


        // Inserisco una visualizzazione della informatica privacy con richiesta di presa visione..

        // console.log('this.infoTitolare', this.infoTitolare)

      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    },

    async creaDocumentoRevoca (row) {

      //// ---------- DA VERIFICARE

      //   // Creare una nuova richiesta di incarico.

      // console.log('REVOCA: creazione documento: ', row)

      await this.$store.dispatch('abilitazioni/loadItemById', row.id)

      let incaricoDoc = this.$store.state.abilitazioni.item

      // console.log('REVOCA: abilitazioni/loadItemById', JSON.stringify(incaricoDoc))

      let rs = await this.$store.dispatch('abilitazioni/addNew',
        {
          codiceUib: incaricoDoc.codiceUib,
          codiceUtente: incaricoDoc.codiceUtente,
          codiceFiscaleIncaricato: incaricoDoc.incaricato.codiceFiscale,
          incaricato: incaricoDoc.incaricato,
          confermaLettura: true,
          tipoDoc: 'revoca',
          idIncarico: incaricoDoc.id
        })

      // // Deve andare sulla pagina relativa al tipo di richiesta selezionato.
      // // Ora va solo su incaricati persone giuridiche.

      let incaricato = incaricoDoc.incaricato

      // console.log('REVOCA: Add incarico from landing', rs, incaricato)

      this.$router.push({ name: 'incaricoInc', params: { id: rs.id } })

      //// ----------
    },


    async onNuovaRichiesta () {
      try {
        // console.log('Crea richiesta nuovo incarico: titolare', this.infoTitolare)
        // console.log('Crea richiesta nuovo incarico: incaricato', this.incaricato.codiceFiscale ? this.incaricato : this.user)

        // Inserisco una visualizzazione della informatica privacy con richiesta di presa visione..

        // this.$refs.modalPrivacy.open({ confermaLettura: this.lettura, titolare: this.infoTitolare, incaricato: this.incaricato.codiceFiscale ? this.incaricato : this.user })
        this.$refs.modalPrivacy.open({ confermaLettura: this.lettura })

        // Verifica coerenza titolare
        // Se tutto OK procede con la creazione della richiesta.

        // console.log('this.infoTitolare', this.infoTitolare)

        // this.$router.push({ name: 'incarico', params: { id: 0 } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    },

    // back () {
    //   this.$router.push({ name: 'home' })
    // },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (err) { }
      // this.$router.push({ name: 'login' })
      this.$router.push({ path: '/entrata' })
    },

    async onRowClicked (row) {
      // console.log('Accedi a una richiesta di icarico', row)
      this.$router.push({ name: 'incaricoInc', params: { id: row.id } })
    },

    async selectLogon (row) {

      this.appRow = Object.assign({}, row)
      await this.$store.dispatch('abilitazioni/loadRUBUItems', row.id)

      // console.log('ItemsRUBU', this.$store.state.abilitazioni.itemsRUBU)

      if (this.$store.state.abilitazioni.itemsRUBU && this.$store.state.abilitazioni.itemsRUBU.length > 0) {
        this.$refs.accessoModal.open({ delegaInfo: row, RUBUItems: this.$store.state.abilitazioni.itemsRUBU })
      } else {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'Nessun RU trovato!.'
        })

      }

    },

    async onLogonInc (row) {

      // Aprire modal per selezione della RU/BU, se 1 sola non attiva selezione
      // this.$refs.modalAccessoSelectRU.open({ codiceFiscaleTIT: row.cftitolare })
      // Selezionato il codice RU con cui procedere si può scegliere se procedere o annullare e quindi tornare alla Landing.

      // Prima di aprire modal verificare presenza di più di una "RU" per il codice_fiscale

      // console.log('Accedi con delega', row, this.appRow)

      if ('45'.search(this.appRow.codiceStatoAbilitazione) > -1 && new Date() <= new Date(this.appRow.fineAbilitazione)) {

        // Richiedi conferma.

        // console.log('Accedi a home!', this.appRow, this.$store.state.auth.user)
        // Assegna delega


        // Questa parte deve essere effettuata lato BE, senza fare la doppia chiamata.
        // Il BE si carica i dati del titolare e restituisce l'oggetto utente pronto per accedere al portale (completo dei dati dell'incaricato).

        // await this.$store.dispatch('abilitazioni/assegnaDelega', { user: userTit, userInc: userInc })
        await this.$store.dispatch('abilitazioni/assegnaDelega', { idDelega: this.appRow.id, utenza: row })

        await this.$store.dispatch('info')

        // console.log('Assegna delega e accedi a home!', userTit, userInc)
        // console.log('Assegna delega this.$store.state.auth.user', this.$store.state.auth.user)

        // Va assegnata la delega anche al BE

        this.$router.push({ name: 'home' })
      }
    },

    isEditable (currentRow, idScope) {
      let retValue = false

      // console.log('idScope: ', idScope)
      if (idScope === 'search') {
        retValue = currentRow.editable !== null
      } else {
        retValue = currentRow.stato === 'P' && currentRow.editable !== 'NO'
      }
      // console.log('Riga corrente: ', currentRow.stato, currentRow.editable, retValue)
      return retValue
    },

    letturaConfermata (value) {
      this.lettura = value.confermaLettura

      // console.log('this.lettura', this.lettura)
      if (this.lettura) {
        this.$refs.modal.open({ confermaLettura: this.lettura, titolare: this.infoTitolare, incaricato: this.incaricato.codiceFiscale ? this.incaricato : this.user })
      }

    },

    accessoIncaricato (dataRow) {
      // console.log('accessoIncaricato', dataRow)
      return `/api/abilitazioni/${dataRow.item.id}/download`
    }

  }
}
</script>


